import { Suspense, lazy } from "react";
import type { IntlConfig } from "react-intl";
import { IntlProvider } from "react-intl";

const DEFAULT_LANG = "en";

const locale = (window.navigator.language || DEFAULT_LANG).split("-")[0];

const LazyLangProvider = lazy(() =>
  import(`../locales/${locale}.json`)
    // if the chosen locale cannot be found, use the default
    .catch(() => import(`../locales/${DEFAULT_LANG}.json`))
    .then(({ default: messages }) => ({
      default: (props: any) => (
        <IntlProvider {...props} messages={messages} locale={locale} />
      ),
    })),
);

export interface LangProps extends Pick<IntlConfig, "timeZone"> {
  children: React.ReactNode;
}

export function LangProvider({ children, timeZone }: LangProps) {
  return (
    <Suspense fallback={null}>
      <LazyLangProvider timeZone={timeZone}>{children}</LazyLangProvider>
    </Suspense>
  );
}
